import {
  Component, OnInit, Input, Output, EventEmitter, ViewContainerRef, IterableDiffers
} from '@angular/core';
import { LookupDataService, ApiRequestService, UserInfoService } from '../../../BaseFramework/core/http'
import { AppMetadataHandler, CommonUtilty } from 'app'
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { Subscription } from 'rxjs';
import { DatePipe } from '@angular/common';
export interface SearchCriteria {
  key: any,
  keyDescription: any,
  valueInputType: any,
  lookupName: any,
  lookup: any,
  enable: any
  isMandatory: any
}

export interface ValidationOutput {
  missingFields: any,
  missingFieldsArray: any,
  errorType: any
}

export interface searchCriteriaUIDO {
  selectedCriteriaKey: any,
  selectedCriteriaKeyDescription: any,
  selectedValue?: any,
  valueInputType: any,
  lookupName: any,
  lookup: any,
  isMandatory: any,
  fromDate : any,
  toDate : any
}

@Component({
  selector: 'app-ui-search',
  templateUrl: './ui-search.component.html',
  styleUrls: ['./ui-search.component.scss'],
  providers : [DatePipe]
})
export class UISearchComponent implements OnInit {

  constructor(
    private lookupDataService: LookupDataService,
    private apiRequestService: ApiRequestService,
    private notification: NzNotificationService,
    private viewContainerRef: ViewContainerRef,
    private userInfoService: UserInfoService,
    private datePipe : DatePipe,
    private _iterableDiffers: IterableDiffers,
    private commonUtility: CommonUtilty,
    private msg: NzMessageService,
    public appMetadataHandler: AppMetadataHandler
  ) {
    this.iterableDiffer = this._iterableDiffers.find([]).create(null);
  }

  rows: Array<searchCriteriaUIDO> = [];
  iterableDiffer : any
  _type: any;
  _searchCriteria: any;
  maxSearchCriteriaLength:any;
  searchObservable : Subscription;

  MISSINGMANDATORYSEARCHCRITERIAS? : any = "MISSINGMANDATORYSEARCHCRITERIAS"
  NOPARAMETERSELECTED? : any = "NOPARAMETERSELECTED"
  INPUTVALUEMANDATORYKEY? : any = 'Input Value for Mandatory Search Criteria'
  INPURVALUEMANDATORY? = null
  MISSINGSEARCHFIELDSISAREKEY? : any = "Mandatory criteria for search is/are"
  MISSINGSEARCHFIELDSISARE? = null
  INCORRECTDATEORDER? : any = "INCORRECTDATEORDER"
  INCORRECTDATEORDERKEY? : any = "From Date cannot be ahead of To Date"

  searchCriteriaUIDO : searchCriteriaUIDO = {
    selectedCriteriaKey: null,
    selectedCriteriaKeyDescription: null,
    selectedValue: null,
    valueInputType: null,
    lookupName: null,
    lookup: null,
    isMandatory: null,
    fromDate : null,
    toDate : null
  }

  ngOnInit() {
    if (this.rows.length === 0) this.addRow()
  }

  @Output() componentOutput = new EventEmitter<any>();
  @Output() criteriaOutput = new EventEmitter<any>();
  @Output() currentRowList = new EventEmitter<any>();

  @Input() searchURL: string
  @Input() dropdownType: string
  @Input() inboxViewName: string
  @Input() searchables: any
  @Input() claimTypeCd: any
  @Input() itemsPerPage: any
  @Input() currentPage: any
  @Input() extraExternalParams: any = []
  @Input() mandatorySearchAttributes: Array<any>
  @Input() set type(value: any) {
    if (value !== null)
      this._type = value
  }
  @Input() set SearchCriteria(value: any) {
    if (value !== null) {
      this._searchCriteria = value;
      this.populateAllLookup(this._searchCriteria);
      this.addMandatoryRows(this._searchCriteria)
      this.setDefaultSearchCriteria(this._searchCriteria);
    }
    else
      this._searchCriteria = this.searchCriteriaUIDO
  }

  get type(): any {
    return this._type;
  }

  get SearchCriteria(): any {
    return this._searchCriteria;
  }

  EmitComponentOutput(data) {
    this.searchAndEmitResultLoading = false
    this.componentOutput.emit(data)
  }

  EmitSelectedCriteria(data) {
    this.currentRowList.emit(this.rows);
    this.criteriaOutput.emit(data);
  }

  getParentComponent(): Component {
    try { return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component } catch { };
  }

  getParentComponentName(): Component {
    try { return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name } catch { };
  }

  //Server Interactions
  populateAllLookup(criteriaArray) {
    if (criteriaArray && typeof criteriaArray === typeof []) {
      criteriaArray.forEach(criteria => {
        if (criteria.lookupName != null)
          this.lookupDataService.getLookup(criteria.lookupName).subscribe(resp => {
            criteria.lookup = resp
            this.setLookupDataToUI(criteria.key, resp);
          })
      })
    } else throw "UI-Search has been used without 'SearchCriteria' in " + this.getParentComponentName();
  }

  ngDoCheck() {
    let changes = this.iterableDiffer.diff(this.SearchCriteria);
    if (changes) {
      this.populateAllLookup(this.SearchCriteria);
      this.addMandatoryRows(this.SearchCriteria)
      this.setDefaultSearchCriteria(this.SearchCriteria)
    }
    this.maxSearchCriteriaLength = this.SearchCriteria.length;
  }

  searchAndEmitResultLoading = false
  searchAndEmitResult() {
    let searchFl: boolean = true;
    for (let obj of this.rows) {
      let extraParams = this.extraExternalParams.find(ext => ext.paramName == obj.selectedCriteriaKey);
      if (!extraParams && (obj.selectedCriteriaKey === null || obj.selectedCriteriaKey === "" ||
        (obj.valueInputType!='DATE' && (obj.selectedValue === null || obj.selectedValue === "")))) {
        this.msg.error("Please enter data in all search fields before proceeding with the search.");
        searchFl = false;
        break;
      }
    }

    if (searchFl) {
      this.searchAndEmitResultLoading = true
      var validationOutput: ValidationOutput = this.validateSearchCriteria()
      if (validationOutput.missingFieldsArray.length === 0 && validationOutput['errorType'] && validationOutput.errorType.length === 0) {
        var payload = this.convertToSearchRequestPayload()
        if (this.searchObservable != null)
          this.searchObservable.unsubscribe();

        this.searchObservable = this.apiRequestService.postCallWithAPIMapper(this.searchURL, payload).subscribe(
          data => {
            this.searchAndEmitResultLoading = false
            if (data && Object.entries(data).length > 0) {
              this.EmitComponentOutput(data)
            } else {
              this.msg.info("No records found.")
              this.EmitComponentOutput(data)
            }
          }
        );

      } else {
        this.searchAndEmitResultLoading = false
      }

      validationOutput.errorType.forEach(error => {
        if (error === this.MISSINGMANDATORYSEARCHCRITERIAS) {
          this.searchAndEmitResultLoading = false
          this.notification.warning(this.INPURVALUEMANDATORY === null ? this.INPUTVALUEMANDATORYKEY : this.INPURVALUEMANDATORY,
            this.MISSINGSEARCHFIELDSISARE === null ? this.MISSINGSEARCHFIELDSISAREKEY : this.MISSINGSEARCHFIELDSISARE + ' - ' + validationOutput.missingFields)
        } else if (error === this.NOPARAMETERSELECTED) {
          this.searchAndEmitResultLoading = false
          this.notification.warning('No Parameter with Value.', 'No parameter with a selected value has been found.');
        } else if (error === this.INCORRECTDATEORDER){
          this.searchAndEmitResultLoading = false
          this.notification.warning('Incorrect Date Order',this.INCORRECTDATEORDERKEY);
        }
        this.searchAndEmitResultLoading = false;
      });
    }
  }

  resetResult() {
    this.searchAndEmitResultLoading = false;
    let mandatoryRows : Array<searchCriteriaUIDO> = this.rows.filter(row=>row.isMandatory==true);
    let remainingRows : Array<searchCriteriaUIDO> = this.rows.filter(row=>!mandatoryRows.includes(row));
    remainingRows.forEach(row => {
      row.selectedCriteriaKey = null;
      row.selectedValue = null;
    })
    if (this.commonUtility.isArrayIterable(this.rows))
      this.rows = [...remainingRows.slice(0, 1),...mandatoryRows];
    this.currentRowList.emit(this.rows);
    this.EmitComponentOutput({ 'reset': true });
  }

  // Local Data Manipulations
  setCaptureDataType(param) {
    let criteriaMetaData = this.getCriteriaObject(param)
    this.rows.forEach(row => {
      if (row.selectedCriteriaKey === param && criteriaMetaData) {
        row.valueInputType = criteriaMetaData.valueInputType
        row.lookupName = criteriaMetaData.lookupName
        row.lookup = criteriaMetaData.lookup
        row.selectedCriteriaKeyDescription = criteriaMetaData.keyDescription
        row.isMandatory = criteriaMetaData.isMandatory
      }
    })
  }

  setLookupDataToUI(key, lookupdata) {
    this.rows.forEach(row => {
      if (row.selectedCriteriaKey === key) {
        row.lookup = lookupdata
      }
    })
  }

  nullifySelectedValue(index) {
    this.rows[index].selectedValue = null
    this.rows[index].fromDate = null
    this.rows[index].toDate = null
  }

  filterSearchCriteria(rows) {
    let searchCriteria = []
    if (this.commonUtility.isArrayIterable(rows) && Array.isArray(searchCriteria)) {
      rows.forEach((criteriaRow, index) => {
        searchCriteria = this.SearchCriteria.filter(sc => sc.key != criteriaRow.selectedCriteriaKey)
      });
    }
    return searchCriteria
  }

  isSearchCriteriaAlreadySelected(key) {
    if (key) {
      let resultSet = this.rows.filter(criteriaRow => criteriaRow.selectedCriteriaKey == key)
      return resultSet.length > 0
    } else return false
  }

  convertToSearchRequestPayload() {
    let payload = {}
    let externalParams = this.extraExternalParams
    payload["page"] = this.currentPage
    payload["size"] = this.itemsPerPage || 10
    payload["searchCriteriaList"] = []

    for (let row of this.rows) {

      var criteriaItem = {}
      let externalParam = externalParams.find(e => e.paramName == row.selectedCriteriaKey) || {}
      if (externalParam.paramName) {
        externalParams = externalParams.filter(e => e.paramName == externalParam.paramName)
      }

      if (this.dropdownType == 'single') {
        let userId = null
        userId = this.userInfoService.getUserId();

        criteriaItem["paramName"] = 'searchkey'
        criteriaItem["paramValue"] = row.selectedCriteriaKey
        payload["searchCriteriaList"].push(criteriaItem)

        criteriaItem = {}
        criteriaItem["paramName"] = 'searchValue'
        if(row.valueInputType=='DATE') 
          criteriaItem["paramValue"] = row.fromDate.trim() + "->" + row.toDate.trim()
        else criteriaItem["paramValue"] = row.selectedValue.trim()
        payload["searchCriteriaList"].push(criteriaItem)

        criteriaItem = {}
        criteriaItem["paramName"] = 'userId'
        criteriaItem["paramValue"] = userId
        payload["searchCriteriaList"].push(criteriaItem)

        criteriaItem = {}
        criteriaItem["paramName"] = 'applicationId'
        criteriaItem["paramValue"] = 'PROVIDERMANAGEMENT'
        payload["searchCriteriaList"].push(criteriaItem)

        criteriaItem = {}
        criteriaItem["paramName"] = 'viewName'
        criteriaItem["paramValue"] = this.inboxViewName
        payload["searchCriteriaList"].push(criteriaItem)
        criteriaItem = {}
      } else {
        criteriaItem["paramName"] = row.selectedCriteriaKey
        criteriaItem["paramType"] = row.valueInputType
        if (row.valueInputType != 'DATE')
          criteriaItem["paramValue"] = externalParams.paramValue || row.selectedValue.trim()
        else {
          let date = new Date(row.fromDate);
          const fromDateString = this.datePipe.transform(date, 'yyyy-MM-dd') || 'null';
          date = new Date(row.toDate);
          const toDateString = this.datePipe.transform(date, 'yyyy-MM-dd') || 'null';
          criteriaItem["paramValue"] = fromDateString + "->" + toDateString;
        }
        payload["searchCriteriaList"].push(criteriaItem)
      }
      if (this.type === 'BULK') {
        let userId = null
        userId = this.userInfoService.getUserId();
        criteriaItem = {}
        criteriaItem["paramName"] = 'userId'
        criteriaItem["paramValue"] = userId
        payload["searchCriteriaList"].push(criteriaItem)
      }
    }

    if (this.commonUtility.isArrayIterable(externalParams) && Array.isArray(payload["searchCriteriaList"]))
      payload["searchCriteriaList"].push(...externalParams)

    return payload
  }

  manipulateExternalParam(selectedCriteria, externalParams) {
    if (selectedCriteria != "commonName") {
      let findIndexOfParam = externalParams.findIndex(item => item.paramName == 'searchTypeCd')
      if (findIndexOfParam != -1)
        externalParams[findIndexOfParam].paramValue = null
    }
    return externalParams
  }

  //Utility Functions
  dropDownOrTextBox(param) {
    let searchObj = this.getCriteriaObject(param)
    return searchObj.valueInputType
  }

  public checkWhetherExternalCriteria(selectedCriteriaKey): any {
    return this.extraExternalParams.find(e => e.paramName == selectedCriteriaKey);
  }

  getCriteriaObject(param) {
    return this.SearchCriteria.find(criteria => criteria.key === param)
  }

  validateSearchCriteria(): ValidationOutput {
    let missingFields = ""
    let missingFieldsArray = []
    let lengthOfParamenter = this.rows.length || 0
    let lengthOfNullValues = 0
    let errorTypes = []

    this.rows.forEach((row : searchCriteriaUIDO) => {
      let count = 0
      if (row.isMandatory && (
        (row.valueInputType!='DATE' && row.selectedValue === null) || 
        (row.valueInputType=='DATE' && (row.fromDate==null || row.toDate==null))
      )) {
        if (count === 0) {
          errorTypes.push(this.MISSINGMANDATORYSEARCHCRITERIAS)
          count += 1
        }
        missingFields += row.selectedCriteriaKeyDescription + " | "
        missingFieldsArray.push(row)
        console.log(row)
      }
      if(row.valueInputType=='DATE' && row.fromDate!=null && row.toDate!=null){
        let fromDateString : Date = new Date(row.fromDate);
        let toDateString : Date = new Date(row.toDate);
        if(fromDateString > toDateString) {
          errorTypes.push(this.INCORRECTDATEORDER)
        }
      }
      let externalParam = this.checkWhetherExternalCriteria(row.selectedCriteriaKey)
      //if present in external params, default the value
      if (externalParam)
        row.selectedValue = externalParam.paramValue
      if ((row.valueInputType!='DATE' && row.selectedValue === null) || (row.valueInputType=='DATE' && (row.fromDate==null || row.toDate==null))) {
        lengthOfNullValues += 1
      }
    })

    if (lengthOfParamenter === lengthOfNullValues) {
      errorTypes.push(this.NOPARAMETERSELECTED)
    }

    return {
      missingFields: missingFields,
      missingFieldsArray: missingFieldsArray,
      errorType: errorTypes
    }
  }

  //UI Triggers
  addRow() {
    var objDummy = JSON.parse(JSON.stringify(this.searchCriteriaUIDO));
    this.rows.push(objDummy);
  }

  setDefaultSearchCriteria(criteriaArray) {
    if (criteriaArray && typeof criteriaArray === typeof []) {
      var me = this
      criteriaArray.forEach(o => {
        if (o.defaultFl) {
          let objDummy: searchCriteriaUIDO = {
            isMandatory: o.isMandatory,
            lookupName: o.lookupName,
            lookup: o.lookup,
            selectedCriteriaKey: o.key,
            selectedCriteriaKeyDescription: o.keyDescription,
            valueInputType: o.valueInputType,
            selectedValue: null,
            fromDate : null,
            toDate : null
          }
          me.rows[0] = objDummy
        }
      })
    }
  }

  addMandatoryRows(criteriaArray) {
    if (criteriaArray && typeof criteriaArray === typeof []) {
      var me = this
      criteriaArray.forEach(o => {
        if (o.isMandatory) {
          let objDummy: searchCriteriaUIDO = {
            isMandatory: o.isMandatory,
            lookupName: o.lookupName,
            lookup: o.lookup,
            selectedCriteriaKey: o.key,
            selectedCriteriaKeyDescription: o.keyDescription,
            valueInputType: o.valueInputType,
            selectedValue: null,
            fromDate : null,
            toDate : null
          }
          me.rows.push(objDummy);
        }
      })
    } else throw "UI-Search has been used without 'SearchCriteria' in " + this.getParentComponentName();
  }

  removeRow(i) {
    this.rows.splice(i, 1);
  }

  criteriaSelected(param, index) {
    let extraParams = this.extraExternalParams.find(ext => ext.paramName == param);
    if (extraParams) {
      this.toggleSearchButtonDisplay = true;
    }
    this.setCaptureDataType(param)
    this.nullifySelectedValue(index)
    this.searchAndEmitResultLoading = false
  }

  toggleSearchButtonDisplay: boolean = false;
  modelChanged(e) {
    this.toggleSearchButtonDisplay = e == "" ? false : true;
  }
  
  showSearchOptions(e) {
    this.toggleSearchButtonDisplay = e == "" ? false : true;
  }

  getFirstRowOfSearch(criteriaArray) {
    if (criteriaArray.length > 0)
      return criteriaArray[0]
    else null
  }

  onPaste(event: ClipboardEvent) {
    setTimeout(() => {
      if (this.rows[0]['selectedValue']) {
        this.rows[0]['selectedValue'] = this.rows[0]['selectedValue'].trim();
      }
    }, 0);
  }

}


